import { ButtonGroup, buttonGroupClasses } from '@mui/material';
import { Route, Routes } from 'react-router-dom';
import RedoContouringButton from './RedoContouringButton';
import UndoContouringButton from './UndoContouringButton';
import { useRecoilValue } from 'recoil';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';

export default function UndoContouringButtons() {
    const selectedStructureSet = useRecoilValue(currentStructureSetState);
    const isDisabled =
        !selectedStructureSet || selectedStructureSet.roiArray.length === 0;

    const renderUndoButtons = () => (
        <>
            <UndoContouringButton disabled={isDisabled} />
            <RedoContouringButton disabled={isDisabled} />
        </>
    );

    return (
        <ButtonGroup
            sx={(theme) => ({
                columnGap: theme.spacing(1),
                [`&.${buttonGroupClasses.root}`]: {
                    ':disabled': { color: 'black' },
                },
                [`& .${buttonGroupClasses.middleButton}, 
                   .${buttonGroupClasses.lastButton}, 
                   .${buttonGroupClasses.firstButton}`]: {
                    borderRadius: theme.shape.borderRadius,
                    border: `1px solid ${theme.palette.divider}`,
                    backgroundColor: 'transparent',
                    color: theme.palette.text.primary,
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover,
                        color: theme.palette.text.primary,
                        border: `1px solid ${theme.palette.divider}`,
                    },
                },
            })}
        >
            <Routes>
                <Route path="contour/*" element={renderUndoButtons()} />
                <Route path="*" element={renderUndoButtons()} />
            </Routes>
        </ButtonGroup>
    );
}
